(function () {
  var CARTHIKE_ENV = "prod";

  var currentScript = document.currentScript;
  var chConfig = null;

  var INSTAMENU_SERVER_URL = "https://localhost";
  if (CARTHIKE_ENV === "dev") {
    INSTAMENU_SERVER_URL = "https://localhost";
  } else if (CARTHIKE_ENV === "prod") {
    INSTAMENU_SERVER_URL = "https://instamenu.carthike.com";
  }

  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  var OC_DOM = new (function () {
    var IS_READY = false;
    var CALLBACKS = [];
    var SELF = this;

    SELF.ready = function (callback) {
      //check to see if we're already finished
      if (IS_READY === true && typeof callback === "function") {
        callback();
        return;
      }

      //else, add this callback to the queue
      CALLBACKS.push(callback);
    };
    var addEvent = function (event, obj, func) {
      if (window.addEventListener) {
        obj.addEventListener(event, func, false);
      } else if (document.attachEvent) {
        obj.attachEvent("on" + event, func);
      }
    };
    var doScrollCheck = function () {
      //check to see if the callbacks have been fired already
      if (IS_READY === true) {
        return;
      }

      //now try the scrolling check
      try {
        document.documentElement.doScroll("left");
      } catch (error) {
        setTimeout(doScrollCheck, 1);
        return;
      }

      //there were no errors with the scroll check and the callbacks have not yet fired, so fire them now
      fireCallbacks();
    };
    var fireCallbacks = function () {
      //check to make sure these fallbacks have not been fired already
      if (IS_READY === true) {
        return;
      }

      //loop through the callbacks and fire each one
      var callback = false;
      for (var i = 0, len = CALLBACKS.length; i < len; i++) {
        callback = CALLBACKS[i];
        if (typeof callback === "function") {
          callback();
        }
      }

      //now set a flag to indicate that callbacks have already been fired
      IS_READY = true;
    };
    var listenForDocumentReady = function () {
      //check the document readystate
      if (document.readyState === "complete") {
        return fireCallbacks();
      }

      //begin binding events based on the current browser
      if (document.addEventListener) {
        addEvent("DOMContentLoaded", document, fireCallbacks);
        addEvent("load", window, fireCallbacks);
      } else if (document.attachEvent) {
        addEvent("load", window, fireCallbacks);
        addEvent("readystatechange", document, fireCallbacks);

        //check for the scroll stuff
        if (document.documentElement.doScroll && window.frameset === null) {
          doScrollCheck();
        }
      }
    };

    //since we have the function declared, start listening
    listenForDocumentReady();
  })();

  OC_DOM.ready(function () {
    if (currentScript.src) {
      var shopOrgin = getParameterByName("shop", currentScript.src);
      if (!shopOrgin && window.Shopify) {
        shopOrgin = window.Shopify.shop;
      }

      if (shopOrgin) {
        getMagicConfig(shopOrgin).then((response) => {
          this.instaMenuConfig = response.config;
          processMenuConfig(response.config);
        });
      }
    }
  });

  function carthike_injectCss(css) {
    /** @type {Element} */
    var style = document.createElement("style");
    /** @type {string} */
    style.type = "text/css";
    /** @type {string} */
    style.rel = "stylesheet";
    style.media = "all";
    try {
      /** @type {string} */
      style.styleSheet.cssText = css;
    } catch (t) {}
    try {
      /** @type {string} */
      style.innerHTML = css;
    } catch (t) {}
    document.getElementsByTagName("head")[0].appendChild(style);
  }
  function getInstaMenuCss(config) {
    return `
              
              
      .main-content {
        margin-top: 0!important
    }
    
    .instamenu_collection {
        background-color: inherit;
        padding-top: 20px;
        padding-bottom: 20px;
        position: sticky;
        width: 100%;
        z-index: 1;
        overflow-x: hidden;
    }
    
    .instamenu_collection a {
        text-decoration: inherit;
        display: flex;
        flex-direction: column;
        align-items: center
    }
    
    .collection_list {
        display: flex;
        justify-content: center;
        overflow-x: auto;
    }
    
    .instamenu_collection .list_items {
        list-style-type: none;
        margin-top: 0;
        margin-bottom: 0;
        padding-left: 0;
        display: flex;
        margin-left: 0
    }
    
    .instamenu_collection .instamenu_listItem {
        display: list-item;
        align-items: center;
        justify-content: center;
        padding: 0 15px
    }
    
    .instamenu_collection .instamenu_listItem:after {
        content: '';
        position: absolute;
        width: 100%;
        transform: scaleX(0);
        height: 2px;
        bottom: 0;
        left: 0;
        background-color: #0087ca;
        transform-origin: bottom right;
        transition: transform .25s ease-out
    }
    
    .instamenu_collection .instamenu_listItem:hover {
        transform: scaleX(1);
        transform-origin: bottom left
    }
    
    .instamenu_collection .instamenu_listItem a.active .item_link {
        color: #423d99;
        font-weight: 900
    }
    
    .instamenu_collection .instamenu_listItem:last-child {
        margin-right: 0
    }
    
    .instamenu_collection .link_img {
        display: block;
        padding-bottom: 10px
    }
    
    .instamenu_collection .link_img img {
        background-size: cover;
        display: block;
        width: 70px;
        border-radius:50%;
        height: auto;
        max-width: inherit
    }
    
    .instamenu_collection .text_link {
        display: block
    }
    
    .instamenu_collection .item_link {
        text-decoration: inherit;
        width: 100%;
        font-size: 11px;
        display: block;
        text-align: center;
        line-height: 1;
        color: rgba(var(--color-foreground),.75);
        text-transform: uppercase;
        font-family: inherit;
        font-weight: inherit;
        white-space: nowrap
    }
    
    span .item_link:hover {
        text-decoration: underline
    }
    
    .instamenu_collection .list_items::-webkit-scrollbar-track {
        background-color: transparent
    }
    
    .instamenu_collection .list_items {
        -ms-overflow-style: none;
        scrollbar-width: none
    }
    
    .instamenu_collection .list_items::-webkit-scrollbar {
        width: 1px;
        background-color: transparent;
        display: none
    }
    
    .instamenu_collection .list_items::-webkit-scrollbar-thumb {
        background-color: transparent
    }
    
   
    @media screen and (max-width: 768px) {
        .instamenu_collection .container {
            padding-left:0;
            padding-right: 0
        }
    
        .menu_collections .list_items {
            overflow-x: auto
        }
    
        .menu_collections .instamenu_listItem:first-child {
            padding-left: 14px
        }
    
        .instamenu_collection {
            width: 100%
        }
    
        .instamenu_collection .list_items {
            overflow: scroll
        }
        .instamenu_collection .link_img img{
            width: 40px;
        }
    }
    
    .collection_list::-webkit-scrollbar {
        scroll-x: none;
        display: none;
    }
    
  
                
          
          `;
  }

  function getMagicConfig(shop) {
    return fetch(
      INSTAMENU_SERVER_URL + "/api/app/public/config?shop=" + shop
    ).then((response) => {
      return response.json();
    });
  }
  function processMenuConfig(config) {
    renderInstaMenu(config);
  }

  function renderInstaMenu(config) {
    carthike_injectCss(getInstaMenuCss(config));

    document.querySelector(".instamenu_collection").style.backgroundColor =
      config.styles.bgColor;
    for (const menuItem of config.menu) {
      const listItem = document.createElement("li");
      listItem.className = "instamenu_listItem";
      const linkTag = document.createElement("a");
      linkTag.href = menuItem.link;
      linkTag.className = "instamenu_link";

      const imageSpan = document.createElement("span");
      imageSpan.className = "link_img";
      const image = document.createElement("img");
      image.loading = "lazy";
      image.height = 100;
      image.width = 100;
      image.style.border = `2px solid ${menuItem.color}`;
      image.src = menuItem.imageUrl;
      image.alt = menuItem.name ? menuItem.name : "";
      imageSpan.appendChild(image);
      const textWrapper = document.createElement("span");
      textWrapper.className = "text_link";
      const linkWrapper = document.createElement("span");
      linkWrapper.className = "item_link";
      const textNode = document.createTextNode(
        menuItem.name ? menuItem.name : ""
      );
      linkWrapper.appendChild(textNode);
      textWrapper.appendChild(linkWrapper);
      linkTag.appendChild(imageSpan);
      linkTag.appendChild(textWrapper);
      listItem.appendChild(linkTag);
      document.querySelector(".instamenu_collection ul").appendChild(listItem);
    }
  }

  function onCartValueUpdated(cartValue) {
    updateCTA(cartValue);
  }
})();
